import BaseStore from './BaseStore';
import { Record } from 'immutable';
import { ActionTypes } from '../constants/AppConstants';

const DefaultAmazonLoginState = new Record({
    amazonEmail: null,
    accessToken: null,
    customer: null,
    hasLoginCompleted: false,
    isProcessing: false,
    status: null,
    isAmazonUser: true
});

export class AmazonLoginStore extends BaseStore {
    deserialize(serialized) {
        if (serialized) {
            return new DefaultAmazonLoginState({
                accessToken: serialized.accessToken
            });
        }
        return new DefaultAmazonLoginState();
    }

    handleEmail({ amazonEmail }) {
        this.setState(this.state.set('amazonEmail', amazonEmail));
    }

    handleLoginAccessToken({ accessToken, hasLoginCompleted, status }) {
        const accessTokenProp = accessToken ? { accessToken } : null;
        const statusProp = status ? { status } : null;

        this.setState(this.state.merge({
            ...accessTokenProp,
            hasLoginCompleted,
            ...statusProp
        }));
    }

    handleProcessingFinished() {
        this.setState(this.state.set('isProcessing', false));
    }

    handleProcessingStarted() {
        this.setState(this.state.merge({
            status: null,
            isProcessing: true
        }));
    }

    handleStatus({ status, customer }) {
        // Do not clear the customer if it's undefined
        const customerProps = typeof customer === 'undefined' ? null : { customer };

        this.setState(this.state.merge({
            status,
            ...customerProps
        }));
    }

    getActionHandlers() {
        return {
            [ActionTypes.AMAZON_LOGIN_LOGIN_ACCESS_TOKEN]: this.handleLoginAccessToken,
            [ActionTypes.AMAZON_LOGIN_EMAIL]: this.handleEmail,
            [ActionTypes.AMAZON_LOGIN_PROCESSING_FINISHED]: this.handleProcessingFinished,
            [ActionTypes.AMAZON_LOGIN_PROCESSING_STARTED]: this.handleProcessingStarted,
            [ActionTypes.AMAZON_LOGIN_STATUS]: this.handleStatus
        };
    }

    getAccessToken() {
        return this.get('accessToken');
    }

    getAmazonEmail() {
        return this.get('amazonEmail');
    }

    getCustomer() {
        const customer = this.get('customer');
        return customer ? customer.toJS() : null;
    }

    getHasLoginCompleted() {
        return this.get('hasLoginCompleted');
    }

    getIsProcessing() {
        return this.get('isProcessing');
    }

    getStatus() {
        return this.get('status');
    }
}

const instance = new AmazonLoginStore();

export default instance;



// WEBPACK FOOTER //
// ./src/stores/AmazonLoginStore.js